export default __webpack_public_path__ + "static/media/coaches-1.43a915f9.jpg";